var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserCirclePurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34 8.5C28.8402 8.49849 23.8014 10.0623 19.5491 12.9849C15.2967 15.9075 12.0311 20.0513 10.1835 24.8689C8.33583 29.6866 7.99317 34.9514 9.20074 39.9679C10.4083 44.9844 13.1093 49.5165 16.9469 52.9656V52.9656C18.5459 49.8167 20.9857 47.1721 23.9957 45.3248C27.0057 43.4776 30.4684 42.4998 34 42.5C31.8986 42.5 29.8443 41.8769 28.0971 40.7094C26.3498 39.5419 24.988 37.8825 24.1838 35.941C23.3796 33.9995 23.1692 31.8632 23.5792 29.8022C23.9891 27.7411 25.0011 25.8479 26.487 24.362C27.9729 22.8761 29.8661 21.8641 31.9272 21.4542C33.9882 21.0442 36.1246 21.2546 38.066 22.0588C40.0075 22.863 41.6669 24.2248 42.8344 25.9721C44.0019 27.7193 44.625 29.7736 44.625 31.875C44.625 34.6929 43.5056 37.3954 41.513 39.388C39.5204 41.3806 36.8179 42.5 34 42.5C37.5316 42.4998 40.9944 43.4776 44.0044 45.3248C47.0144 47.1721 49.4541 49.8167 51.0531 52.9656C54.8907 49.5165 57.5917 44.9844 58.7993 39.9679C60.0068 34.9514 59.6642 29.6866 57.8166 24.8689C55.9689 20.0513 52.7033 15.9075 48.451 12.9849C44.1987 10.0623 39.1598 8.49849 34 8.5Z",
    fill: "#7032D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 59.5C48.0833 59.5 59.5 48.0833 59.5 34C59.5 19.9167 48.0833 8.5 34 8.5C19.9167 8.5 8.5 19.9167 8.5 34C8.5 48.0833 19.9167 59.5 34 59.5Z",
    stroke: "#7032D8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42.5C39.868 42.5 44.625 37.743 44.625 31.875C44.625 26.007 39.868 21.25 34 21.25C28.132 21.25 23.375 26.007 23.375 31.875C23.375 37.743 28.132 42.5 34 42.5Z",
    stroke: "#7032D8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9469 52.9655C18.5457 49.8163 20.9854 47.1714 23.9954 45.3238C27.0054 43.4763 30.4682 42.4983 34 42.4983C37.5318 42.4983 40.9947 43.4763 44.0047 45.3238C47.0147 47.1714 49.4543 49.8163 51.0531 52.9655",
    stroke: "#7032D8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCirclePurple);
export default __webpack_public_path__ + "static/media/UserCirclePurple.4e4bae6de5f8934a658dac28aa1c17b4.svg";
export { ForwardRef as ReactComponent };